import { Skeleton } from 'antd';
import React from 'react';
import { addCommas } from 'utils/shared';

// const data = [
//     { name: 'IIFL Finance', amount: '$721,882', change: '-4.66%', img: '/img/Down.png' },
//     { name: 'Power Finance', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
//     { name: 'REC Limited', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
//     { name: 'NTPC Limited', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
//     { name: 'IIFL Finance', amount: '$721,882', change: '-4.66%', img: '/img/Down.png' },
//     { name: 'Power Finance', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
//     { name: 'REC Limited', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
//     { name: 'NTPC Limited', amount: '$48,676', change: '+0.38%', img: '/img/Shape.svg' },
// ];

const MarketCap = ({ marketCap, handleMarkupClick }) => {
    return (
        <div>
            <div className='flex justify-between items-center  px-6 pb-5 border-b-[1px]'>
                <div className='flex items-center font-bold text-xl'>
                    <div><img className='h-4' src='/img/Path 2.svg' alt='' /></div>
                    <div>MarketCap</div>
                </div>
                <div>
                    <img className='h-6' src='/img/left.svg' alt='' />
                </div>
            </div>
            {marketCap?.length ?
                <>
                    {marketCap?.map((item, index) => (
                        <div key={index} className='flex justify-between px-6 py-4 items-center border-b-[1px] cursor-pointer hover:bg-gray-100' onClick={() => { handleMarkupClick(item) }}>
                            <div className='text-xs md:text-sm lg:text-base'>{item?.name}</div>
                            <div className={`flex items-center gap-3 text-[10px] md:text-sm lg:text-base `}>
                                <div>${addCommas(item?.market_cap)}</div>
                                <div className={item?.day_change_percent > 0 ? 'text-seaGreen' : 'text-[#EE2E6B]'}>{item?.day_change_percent?.toFixed(2)}%</div>
                                <div><img src={item?.day_change_percent > 0 ? "/img/Shape.svg" : '/img/Down.png'} alt='' /></div>
                            </div>
                        </div>
                    ))
                    }
                </> :
                <Skeleton />
            }
        </div >
    );
};

export default MarketCap;
